module.exports = __webpack_public_path__ + "static/img/son16_active.0d3063ae.png";